import ArrowLeftIcon from '@/common/assets/icons/arrow-left.svg?react';
import EditIcon from '@/common/assets/icons/editIcon.svg?react';
import EducationIcon from '@/common/assets/icons/education.svg?react';
import ExitIcon from '@/common/assets/icons/exitIcon.svg?react';
import AboutUsIcon from '@/common/assets/icons/infoCircleIcon.svg?react';
import ProfilePictureIcon from '@/common/assets/icons/profilePictureIcon.svg?react';
import WalletIcon from '@/common/assets/icons/WalletProfile.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import CardButton from '@/common/components/cardButton/CardButton.tsx';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import useModal from '@/common/hooks/useModal.ts';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import LogoutModal from '@/modules/Dashboard/components/modals/LogoutModal.tsx';
import { DASHBOARD_LINKS } from '@/modules/Dashboard/DashboardLinks.ts';
import { sidebarQueryOptions } from '@/modules/Dashboard/queries/sidebar/sidebarQueryOptions.ts';
import { EDUCATION_LINKS } from '@/modules/Education/EducationLinks';
import PieChartIcon from '@/modules/Statistics/assets/icons/pie-chart.svg?react';
import { STATISTIC_LINKS } from '@/modules/Statistics/StatisticsLinks';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Box, Center, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import { numberSeparator } from '../utils/numberSeparator';

export default () => {
  return (
    <MainLayout title="" header="none" navbar>
      <Profile />
    </MainLayout>
  );
};

const Profile = () => {
  const { data, isPending, isError } = useQuery(sidebarQueryOptions);
  const navigate = useNavigate();
  const {
    open: isLogoutModalOpen,
    closeModal: closeLogoutModal,
    openModal: openLogoutModal,
  } = useModal();

  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }
  return (
    <>
      <Center flexDirection="column">
        <Box mb="20px">
          <ProfilePictureIcon />
        </Box>
        <Typography textAlign="center">{data?.fullName}</Typography>
      </Center>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        height="64px"
        borderRadius="12px"
        px="16px"
        mx="auto"
        mt="20px"
        direction="rtl"
        bg="linear-gradient(90deg, rgba(99, 45, 246, 1) 0%, rgba(152, 114, 255, 1) 100%)"
        boxShadow="0px 2px 10px 0px rgba(191, 191, 191, 0.1)"
        onClick={() => navigate(DASHBOARD_LINKS.wallet)}
      >
        <Flex alignItems="center" gap="8px" color="white">
          <WalletIcon />
          <Typography color="white">کیف پول</Typography>
        </Flex>

        <Flex alignItems="center" color="white" gap={6}>
          <Flex alignItems="center" gap={4}>
            <Typography textStyle="h1" color="white">
              {numberSeparator(data?.wallet)}
            </Typography>
            <Typography color="white" fontSize="12px">
              ریال
            </Typography>
          </Flex>
          <ArrowLeftIcon />
        </Flex>
      </Flex>

      <Box
        borderRadius="16px"
        backgroundColor="white"
        shadow="cardShadow"
        py="5px"
        mt="20px"
      >
        <CardButton
          title="آمار و عملکرد"
          hasRate
          starData={data?.performance_score}
          cardProps={{
            boxShadow: 'none',
            onClick: () => navigate(STATISTIC_LINKS.statistic),
          }}
          renderIcon={() => (
            <CustomIcon backgroundColor="green-4" width="40px" height="40px">
              <PieChartIcon height="24px" width="24px" />
            </CustomIcon>
          )}
        />
        <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
        <CardButton
          title="آموزش"
          cardProps={{
            boxShadow: 'none',
            onClick: () => navigate(EDUCATION_LINKS.education),
          }}
          renderIcon={() => (
            <CustomIcon backgroundColor="green-4" width="40px" height="40px">
              <EducationIcon height="24px" width="24px" />
            </CustomIcon>
          )}
        />
        <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
        <CardButton
          title="ثبت امضا"
          cardProps={{
            boxShadow: 'none',
            onClick: () => navigate(DASHBOARD_LINKS.signature),
          }}
          renderIcon={() => (
            <CustomIcon backgroundColor="blue-2" width="40px" height="40px">
              <EditIcon
                height="24px"
                width="24px"
                stroke={token('colors.blue')}
              />
            </CustomIcon>
          )}
        />
        <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
        <CardButton
          title="درباره ما"
          cardProps={{
            boxShadow: 'none',
            onClick: () => {
              navigate(DASHBOARD_LINKS.aboutUs);
            },
          }}
          renderIcon={() => (
            <CustomIcon backgroundColor="green-4" width="40px" height="40px">
              <AboutUsIcon
                height="24px"
                width="24px"
                stroke={token('colors.green-2')}
              />
            </CustomIcon>
          )}
        />
        <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
        <CardButton
          title="خروج از حساب کاربری"
          cardProps={{ boxShadow: 'none', onClick: openLogoutModal }}
          renderIcon={() => (
            <CustomIcon backgroundColor="pink-2" width="40px" height="40px">
              <ExitIcon
                height="24px"
                width="24px"
                stroke={token('colors.pink')}
              />
            </CustomIcon>
          )}
        />
      </Box>
      <LogoutModal open={isLogoutModalOpen} closeModal={closeLogoutModal} />
    </>
  );
};
